// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[6].use[1]!../../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.5.6_webpack@5.105.1_esbuild@0.28.1_/node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[6].use[2]!../../../node_modules/.pnpm/resolve-url-loader@4.0.0/node_modules/resolve-url-loader/index.js??ruleSet[1].rules[0].oneOf[6].use[3]!../../../node_modules/.pnpm/sass-loader@12.6.0_sass@1.97.3_webpack@5.105.1_esbuild@0.28.1_/node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[6].use[4]!../../../node_modules/.pnpm/keen-slider@6.8.6_react@18.3.1/node_modules/keen-slider/keen-slider.min.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes fadeInMixin {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@keyframes fadeOutMixin {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
:is(h1, h2, h3, h4, h5, h6, p, span):not(:where(.zai-chat-package *)) {
  margin: 0px;
  font-family: "Muli", Arial, sans-serif;
}
:is(h1, h2, h3, h4, h5, h6, p, span):not(:where(.zai-chat-package *)).light {
  font-weight: 300;
}
:is(h1, h2, h3, h4, h5, h6, p, span):not(:where(.zai-chat-package *)).regular {
  font-weight: 400;
}
:is(h1, h2, h3, h4, h5, h6, p, span):not(:where(.zai-chat-package *)).semi {
  font-weight: 600;
}
:is(h1, h2, h3, h4, h5, h6, p, span):not(:where(.zai-chat-package *)).bold {
  font-weight: 700;
}

:is(h1, h2, h3, h4, h5, h6):not(:where(.zai-chat-package *)) {
  color: var(--gray_dark2);
}

:is(p):not(:where(.zai-chat-package *)) {
  font-size: 1rem;
}

:is(h1):not(:where(.zai-chat-package *)) {
  font-size: 3rem;
}

:is(h2):not(:where(.zai-chat-package *)) {
  font-size: 2.25rem;
}

:is(h3):not(:where(.zai-chat-package *)) {
  font-size: 1.5rem;
}

:is(h4):not(:where(.zai-chat-package *)) {
  font-size: 1.25rem;
}

:is(h5):not(:where(.zai-chat-package *)) {
  font-size: 1rem;
}

:is(h6):not(:where(.zai-chat-package *)) {
  font-size: 0.875rem;
}

#adopt-controller-button {
  bottom: 72px !important;
  right: 16px !important;
}
#adopt-controller-button svg > path {
  fill: rgb(192, 192, 192) !important;
}

html {
  box-sizing: border-box;
}

*,
*::after,
*::before {
  box-sizing: inherit;
}

#root {
  display: flex;
  flex-direction: column;
}

body {
  font-family: "Muli", Arial, sans-serif;
  font-weight: 400;
  font-size: 16px;
  font-feature-settings: none;
  font-variant-ligatures: none;
  text-rendering: geometricPrecision;
  margin: 0;
  padding: 0;
  color: var(--gray);
  background-color: var(--base_color2);
  overflow-y: scroll;
  min-height: 100vh;
  transition: margin-bottom 200ms;
}
body .apexcharts-canvas .apexcharts-toolbar {
  z-index: 1;
}

:is(button, input, select, textarea):not(:where(.zai-chat-package *)) {
  font-family: inherit;
  font-weight: inherit;
  font-size: inherit;
  color: inherit;
}

:is(*:focus):not(:where(.zai-chat-package *)) {
  outline: none;
}

:is(img):not(:where(.zai-chat-package *)) {
  max-width: 100%;
}

:is(a, a:visited):not(:where(.zai-chat-package *)) {
  text-decoration: none;
}

:is(button):not(:where(.zai-chat-package *)) {
  background-color: transparent;
  border: none;
  cursor: pointer;
}

.link-color {
  color: var(--color_primary_500);
}

:is(.sidebar-widget):not(:where(.zai-chat-package *)) {
  margin-top: 16px;
  border-radius: 4px;
  background-color: var(--base_color2);
  padding: 16px;
}
:is(.sidebar-widget):not(:where(.zai-chat-package *)) h4 {
  margin-top: 0;
  margin-bottom: 8px;
  font-weight: bold;
  font-size: 1.125em;
}
:is(.sidebar-widget):not(:where(.zai-chat-package *)) h4 .subtitle {
  display: block;
  font-size: 0.7em;
}

:is(.bg-white):not(:where(.zai-chat-package *)) {
  background-color: var(--base_color2);
}

.page-header {
  position: relative;
  z-index: 3;
  margin-bottom: 20px;
}

.page-content {
  z-index: 1;
}

.grid-2-columns {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 20px;
}

.title-content {
  display: grid;
  grid-template-areas: "title" "content";
  grid-row-gap: 16px;
  grid-template-rows: -webkit-min-content;
  grid-template-rows: min-content;
  margin: 0 0 56px;
}

.title-content-actions {
  display: grid;
  grid-template-areas: "title" "content" "actions";
  grid-row-gap: 16px;
  grid-template-rows: -webkit-min-content;
  grid-template-rows: min-content;
  margin: 0 0 20px;
}

.title-actions-content {
  margin: 30px 0 56px;
  display: grid;
  grid-template-areas: "title actions" "content content";
  grid-row-gap: 16px;
  grid-template-rows: -webkit-min-content;
  grid-template-rows: min-content;
}
.title-actions-content > .title {
  grid-area: title;
  align-self: center;
}
.title-actions-content > .actions {
  grid-area: actions;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.title-actions-content > .actions > * {
  margin: 0 0 0 28px;
}
.title-actions-content > .content {
  grid-area: content;
}
.title-actions-content > .actions-secondary {
  grid-area: actions-secondary;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.title-actions-content.with-actions-secondary {
  margin: 0 0 20px;
  grid-template-areas: "title actions" "content content" "actions-secondary actions-secondary";
}

.actions-box {
  display: grid;
  grid-template-areas: "left center right";
  grid-column-gap: 20px;
}
.actions-box .actions-left {
  grid-area: left;
  display: flex;
  justify-content: flex-start;
}
.actions-box .actions-center {
  grid-area: center;
  display: flex;
  justify-content: center;
}
.actions-box .actions-right {
  grid-area: right;
  display: flex;
  justify-content: flex-end;
}

.apexcharts-tooltip,
.custom-toltip-container,
.tooltip-component {
  color: var(--gray_dark2);
}

.tooltipped {
  position: relative;
}

.tooltipped::after {
  position: absolute;
  z-index: 1000000;
  display: none;
  padding: 5px 5px 7px;
  font: normal normal 13px/1.5 "Muli";
  -webkit-font-smoothing: subpixel-antialiased;
  color: var(--base_color2);
  text-align: center;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-wrap: break-word;
  white-space: pre;
  pointer-events: none;
  content: attr(aria-label);
  background: var(--base_color1);
  border-radius: 4px;
  opacity: 0;
}

.tooltipped::before {
  position: absolute;
  z-index: 1000001;
  display: none;
  width: 0;
  height: 0;
  color: var(--base_color1);
  pointer-events: none;
  content: "";
  border: 6px solid transparent;
  opacity: 0;
}

@keyframes tooltip-appear {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.tooltipped:hover::before, .tooltipped:hover::after,
.tooltipped:active::before,
.tooltipped:active::after,
.tooltipped:focus::before,
.tooltipped:focus::after {
  display: inline-block;
  text-decoration: none;
  animation-name: tooltip-appear;
  animation-duration: 0.1s;
  animation-fill-mode: forwards;
  animation-timing-function: ease-in;
  animation-delay: 0.4s;
}

.tooltipped-no-delay:hover::before, .tooltipped-no-delay:hover::after,
.tooltipped-no-delay:active::before,
.tooltipped-no-delay:active::after,
.tooltipped-no-delay:focus::before,
.tooltipped-no-delay:focus::after {
  animation-delay: 0s;
}

.tooltipped-multiline:hover::after,
.tooltipped-multiline:active::after,
.tooltipped-multiline:focus::after {
  display: table-cell;
}

.tooltipped-s::after {
  top: 100%;
  right: 50%;
  margin-top: 6px;
}
.tooltipped-s::before {
  top: auto;
  right: 50%;
  bottom: -7px;
  margin-right: -6px;
  border-bottom-color: var(--base_color1);
}

.tooltipped-n::after,
.tooltipped-ne::after,
.tooltipped-nw::after {
  right: 50%;
  bottom: 100%;
  margin-bottom: 6px;
}
.tooltipped-n .tooltipped-ne::after,
.tooltipped-ne .tooltipped-ne::after,
.tooltipped-nw .tooltipped-ne::after {
  right: auto;
  left: 50%;
  margin-left: -0.125em;
}
.tooltipped-n::before,
.tooltipped-ne::before,
.tooltipped-nw::before {
  top: -7px;
  right: 50%;
  bottom: auto;
  margin-right: -6px;
  border-top-color: var(--base_color1);
}

.tooltipped-ne::after {
  right: auto;
  left: 50%;
  margin-left: -12px;
}

.tooltipped-nw::after {
  margin-right: -12px;
}

.tooltipped-s::after,
.tooltipped-n::after {
  transform: translateX(50%);
}

.tooltipped-w::after {
  right: 100%;
  bottom: 50%;
  margin-right: 6px;
  transform: translateY(50%);
}
.tooltipped-w::before {
  top: 50%;
  bottom: 50%;
  left: -7px;
  margin-top: -6px;
  border-left-color: var(--base_color1);
}

.tooltipped-e::after {
  bottom: 50%;
  left: 100%;
  margin-left: 6px;
  transform: translateY(50%);
}
.tooltipped-e::before {
  top: 50%;
  right: -7px;
  bottom: 50%;
  margin-top: -6px;
  border-right-color: var(--base_color1);
}

.tooltipped-multiline::after {
  width: -webkit-max-content;
  width: -moz-max-content;
  width: max-content;
  max-width: 225px;
  word-wrap: break-word;
  white-space: pre-line;
  border-collapse: separate;
  text-align: left;
  padding: 14px;
}
.tooltipped-multiline.tooltipped-s::after, .tooltipped-multiline.tooltipped-n::after {
  right: auto;
  left: 50%;
  transform: translateX(-50%);
}
.tooltipped-multiline.tooltipped-w::after, .tooltipped-multiline.tooltipped-e::after {
  right: 100%;
}

@media screen and (min-width: 0\\0 ) {
  .tooltipped-multiline::after {
    width: 225px;
  }
}
.notAllowed.displayBlock {
  display: block;
}
.notAllowed.tooltipped-multiline:after {
  width: 150px;
}
.notAllowed {
  cursor: pointer;
}
.notAllowed .isClickBlocked {
  pointer-events: none;
}

.link-as-button {
  background: var(--color_primary_500);
  color: var(--base_color2);
  font-size: 14px;
  padding: 6px 16px;
  line-height: 24px;
  font-weight: 400;
  border: 1px solid var(--color_primary_500);
  border-radius: 4px;
}
.link-as-button:hover {
  background: var(--primary_dark1);
}

.provider {
  height: 26px;
  width: 26px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.provider.youtube {
  background-color: var(--youtube);
}
.provider.facebook {
  background-color: var(--facebook);
}
.provider.instagram {
  background-color: var(--instagram);
}
.provider.tiktok {
  background-color: var(--tiktok);
}
.provider.twitch {
  background-color: var(--twitch);
}
.provider .icon {
  height: 16px;
  width: 16px;
  fill: var(--base_color2);
}

.column-headers {
  background-color: var(--background);
  border-radius: 4px;
  font-weight: 600;
  font-size: 12px;
  line-height: 15px;
  color: var(--gray_dark2);
}
.column-headers .header_active {
  color: var(--color_primary_500);
}
.column-headers .header-sortable span {
  margin: 0 4px 0 0;
}

.pin-block {
  justify-self: center;
  justify-content: center;
  display: flex;
  align-items: center;
}

.CreatorCard .pin-block-card {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
}

.VideoCard .pin-block-card {
  position: absolute;
  top: 8px;
  left: 8px;
  z-index: 1;
}

.ContainerToasts {
  position: fixed;
  left: 50px;
  bottom: 20px;
  z-index: 9999;
  width: -webkit-fit-content;
  width: -moz-fit-content;
  width: fit-content;
  max-width: 432px;
  min-width: 350px;
}

.PrivateRoute {
  padding-left: 72px;
}
@media only screen and (max-width: 600px) {
  .PrivateRoute {
    padding-left: 0px;
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    max-height: 100vh;
  }
  .PrivateRoute > * {
    flex-shrink: 0;
  }
}
.PrivateRoute.fullScreen {
  padding-left: 0px;
}

@media screen and (max-width: 768px) {
  .hiddenOnMobile {
    display: none;
  }
}

@media screen and (min-width: 768px) {
  .hiddenOnDesktop {
    display: none;
  }
}

.osano-cm-widget--position_right {
  width: 55px;
  height: 55px;
  opacity: 0.5;
  border-radius: 50%;
  right: 16px;
  bottom: 72px;
  background-color: #c0c0c0;
}
.osano-cm-widget--position_right .osano-cm-widget__outline {
  stroke: #c0c0c0;
}
.osano-cm-widget--position_right .osano-cm-widget__dot {
  fill: #c0c0c0;
}`, "",{"version":3,"sources":["webpack://./src/mixins.scss","webpack://./src/index.scss"],"names":[],"mappings":"AAwCA;EACE;IACE,UAAA;ECtCF;EDwCA;IACE,UAAA;ECtCF;AACF;ADyCA;EACE;IACE,UAAA;ECvCF;EDyCA;IACE,UAAA;ECvCF;AACF;ADqEE;EC3EA,WAAA;EACA,sCAAA;AASF;AAPE;EACE,gBAAA;AASJ;AAPE;EACE,gBAAA;AASJ;AAPE;EACE,gBAAA;AASJ;AAPE;EACE,gBAAA;AASJ;;ADqDE;ECzDA,wBAAA;AAQF;;ADiDE;ECrDA,eAAA;AAQF;;AD6CE;ECjDA,eAAA;AAQF;;ADyCE;EC9CA,kBAAA;AASF;;ADqCE;EC3CA,iBAAA;AAUF;;ADiCE;ECxCA,kBAAA;AAWF;;AD6BE;ECrCA,eAAA;AAYF;;ADyBE;EClCA,mBAAA;AAaF;;AAVA;EACE,uBAAA;EACA,sBAAA;AAaF;AAXE;EACE,mCAAA;AAaJ;;AATA;EACE,sBAAA;AAYF;;AATA;;;EAGE,mBAAA;AAYF;;AATA;EACE,aAAA;EACA,sBAAA;AAYF;;AATA;EACE,sCAAA;EACA,gBAAA;EACA,eAAA;EACA,2BAAA;EAAA,4BAAA;EACA,kCAAA;EACA,SAAA;EACA,UAAA;EACA,kBAAA;EACA,oCAAA;EACA,kBAAA;EACA,iBAAA;EACA,+BAAA;AAYF;AATI;EACE,UAAA;AAWN;;ADpBE;ECeA,oBAAA;EACA,oBAAA;EACA,kBAAA;EACA,cAAA;AASF;;AD3BE;ECsBA,aAAA;AASF;;AD/BE;EC0BA,eAAA;AASF;;ADnCE;EC8BA,qBAAA;AASF;;ADvCE;ECkCA,6BAAA;EACA,YAAA;EACA,eAAA;AASF;;AANA;EACE,+BAAA;AASF;;ADjDE;EC4CA,gBAAA;EACA,kBAAA;EACA,oCAAA;EACA,aAAA;AASF;AAPE;EACE,aAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;AASJ;AAPI;EACE,cAAA;EACA,gBAAA;AASN;;ADlEE;EC+DA,oCAAA;AAOF;;AAJA;EACE,kBAAA;EACA,UAAA;EACA,mBAAA;AAOF;;AAJA;EACE,UAAA;AAOF;;AAHA;EACE,aAAA;EACA,8BAAA;EACA,qBAAA;AAMF;;AAFA;EACE,aAAA;EACA,sCACE;EAEF,kBAAA;EACA,uCAAA;EAAA,+BAAA;EACA,gBAAA;AAGF;;AACA;EACE,aAAA;EACA,gDACE;EAGF,kBAAA;EACA,uCAAA;EAAA,+BAAA;EACA,gBAAA;AADF;;AAKA;EACE,mBAAA;EACA,aAAA;EACA,sDACE;EAEF,kBAAA;EACA,uCAAA;EAAA,+BAAA;AAJF;AAME;EACE,gBAAA;EACA,kBAAA;AAJJ;AAOE;EACE,kBAAA;EACA,aAAA;EACA,yBAAA;EACA,mBAAA;AALJ;AAOI;EACE,kBAAA;AALN;AASE;EACE,kBAAA;AAPJ;AAUE;EACE,4BAAA;EACA,aAAA;EACA,yBAAA;EACA,mBAAA;AARJ;AAWE;EACE,gBAAA;EACA,4FACE;AAVN;;AAiBA;EACE,aAAA;EACA,wCAAA;EACA,qBAAA;AAdF;AAgBE;EACE,eAAA;EACA,aAAA;EACA,2BAAA;AAdJ;AAiBE;EACE,iBAAA;EACA,aAAA;EACA,uBAAA;AAfJ;AAkBE;EACE,gBAAA;EACA,aAAA;EACA,yBAAA;AAhBJ;;AAoBA;;;EAGE,wBAAA;AAjBF;;AA0BA;EACE,kBAAA;AAvBF;;AA2BA;EACE,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,oBAAA;EACA,mCAAA;EACA,4CAAA;EACA,yBAAA;EACA,kBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,qBAAA;EACA,gBAAA;EACA,oBAAA;EACA,yBAAA;EACA,8BAAA;EACA,kBAAA;EACA,UAAA;AAxBF;;AA4BA;EACE,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,QAAA;EACA,SAAA;EACA,yBAAA;EACA,oBAAA;EACA,WAAA;EACA,6BAAA;EACA,UAAA;AAzBF;;AA6BA;EACE;IACE,UAAA;EA1BF;EA6BA;IACE,UAAA;EA3BF;AACF;AAkCE;;;;;EAEE,qBAAA;EACA,qBAAA;EACA,8BAAA;EACA,wBA/De;EAgEf,6BAAA;EACA,kCAAA;EACA,qBAnEY;AAsChB;;AAoCE;;;;;EAEE,mBAAA;AA9BJ;;AAqCE;;;EACE,mBAAA;AAhCJ;;AAsCE;EACE,SAAA;EACA,UAAA;EACA,eAAA;AAnCJ;AAsCE;EACE,SAAA;EACA,UAAA;EACA,YAAA;EACA,kBAAA;EACA,uCAAA;AApCJ;;AA4CE;;;EACE,UAAA;EACA,YAAA;EACA,kBAAA;AAvCJ;AA2CI;;;EACE,WAAA;EACA,SAAA;EACA,qBAAA;AAvCN;AA2CE;;;EACE,SAAA;EACA,UAAA;EACA,YAAA;EACA,kBAAA;EACA,oCAAA;AAvCJ;;AA4CE;EACE,WAAA;EACA,SAAA;EACA,kBAAA;AAzCJ;;AA6CA;EACE,mBAAA;AA1CF;;AA8CA;;EAEE,0BAAA;AA3CF;;AAgDE;EACE,WAAA;EACA,WAAA;EACA,iBAAA;EACA,0BAAA;AA7CJ;AAgDE;EACE,QAAA;EACA,WAAA;EACA,UAAA;EACA,gBAAA;EACA,qCAAA;AA9CJ;;AAoDE;EACE,WAAA;EACA,UAAA;EACA,gBAAA;EACA,0BAAA;AAjDJ;AAoDE;EACE,QAAA;EACA,WAAA;EACA,WAAA;EACA,gBAAA;EACA,sCAAA;AAlDJ;;AA4DE;EACE,0BAAA;EAAA,uBAAA;EAAA,kBAAA;EACA,gBArMgB;EAsMhB,qBAAA;EACA,qBAAA;EACA,yBAAA;EACA,gBAAA;EACA,aAAA;AAzDJ;AA4DE;EAEE,WAAA;EACA,SAAA;EACA,2BAAA;AA3DJ;AA8DE;EAEE,WAAA;AA7DJ;;AAiEA;EAEE;IACE,YA7NgB;EA8JlB;AACF;AAmEE;EACE,cAAA;AAjEJ;AAqEI;EACE,YAAA;AAnEN;AA4DA;EAWE,eAAA;AApEF;AAsEE;EACE,oBAAA;AApEJ;;AAwEA;EACE,oCAAA;EACA,yBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,0CAAA;EACA,kBAAA;AArEF;AAuEE;EACE,gCAAA;AArEJ;;AAyEA;EACE,YAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;AAtEF;AAwEE;EACE,gCAAA;AAtEJ;AAyEE;EACE,iCAAA;AAvEJ;AA0EE;EACE,kCAAA;AAxEJ;AA2EE;EACE,+BAAA;AAzEJ;AA4EE;EACE,+BAAA;AA1EJ;AA6EE;EACE,YAAA;EACA,WAAA;EACA,wBAAA;AA3EJ;;AA+EA;EACE,mCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,wBAAA;AA5EF;AA8EE;EACE,+BAAA;AA5EJ;AAgFI;EACE,iBAAA;AA9EN;;AAmFA;EACE,oBAAA;EACA,uBAAA;EACA,aAAA;EACA,mBAAA;AAhFF;;AAoFE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;AAjFJ;;AAsFE;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;AAnFJ;;AAuFA;EACE,eAAA;EACA,UAAA;EACA,YAAA;EACA,aAAA;EACA,0BAAA;EAAA,uBAAA;EAAA,kBAAA;EACA,gBAAA;EACA,gBAAA;AApFF;;AAuFA;EACE,kBAAA;AApFF;AAsFE;EAHF;IAII,iBAAA;IACA,aAAA;IACA,sBAAA;IACA,iBAAA;IACA,iBAAA;EAnFF;EAqFE;IACE,cAAA;EAnFJ;AACF;AAsFE;EACE,iBAAA;AApFJ;;AAyFE;EADF;IAEI,aAAA;EArFF;AACF;;AAyFE;EADF;IAEI,aAAA;EArFF;AACF;;AAwFA;EACE,WAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;AArFF;AAuFE;EACE,eAAA;AArFJ;AAwFE;EACE,aAAA;AAtFJ","sourcesContent":["@mixin line-clamp($lines, $wordBreak: break-word) {\n  display: -webkit-box;\n  line-clamp: $lines;\n  -webkit-line-clamp: $lines;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  word-break: $wordBreak;\n}\n\n@mixin scrollbar(\n  $color: var(--color_neutral_200),\n  $colorHover: var(--color_neutral_400),\n  $colorActive: var(--color_neutral_500)\n) {\n  &::-webkit-scrollbar {\n    width: 7px;\n    height: 7px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: transparent;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: $color;\n    height: 80px;\n    border-radius: 50px;\n  }\n\n  &:hover {\n    &::-webkit-scrollbar-thumb {\n      background: $colorHover;\n    }\n  }\n\n  &::-webkit-scrollbar-thumb:active {\n    background: $colorActive;\n  }\n}\n\n@keyframes fadeInMixin {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n\n@keyframes fadeOutMixin {\n  0% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 0;\n  }\n}\n\n@mixin fadeIn($timing, $length, $delay, $fill) {\n  animation: fadeInMixin $timing $length $delay;\n  animation-fill-mode: $fill;\n}\n\n@mixin fadeOut($timing, $length, $delay, $fill) {\n  animation: fadeOutMixin $timing $length $delay;\n  animation-fill-mode: $fill;\n}\n\n@mixin noise {\n  position: relative;\n  &::after {\n    content: '';\n    position: absolute;\n    inset: 0;\n    z-index: -1;\n    background-image: url('./assets/images/png/noise.png');\n    background-position: 0% 0%;\n    background-size: 36.23046875px 36.23046875px;\n    background-repeat: repeat;\n    border-radius: 12px;\n    opacity: 0.3;\n  }\n}\n\n@mixin scoped-excluded($selector, $exclude-class) {\n  :is(#{$selector}):not(:where(#{$exclude-class} *)) {\n    @content;\n  }\n}\n","@import 'keen-slider/keen-slider.min.css';\n@import './mixins.scss';\n\n@mixin scoped-zai-excluded($selector) {\n  @include scoped-excluded($selector, '.zai-chat-package') {\n    @content;\n  }\n}\n\n@include scoped-zai-excluded('h1, h2, h3, h4, h5, h6, p, span') {\n  margin: 0px;\n  font-family: 'Muli', Arial, sans-serif;\n\n  &.light {\n    font-weight: 300;\n  }\n  &.regular {\n    font-weight: 400;\n  }\n  &.semi {\n    font-weight: 600;\n  }\n  &.bold {\n    font-weight: 700;\n  }\n}\n\n@include scoped-zai-excluded('h1, h2, h3, h4, h5, h6') {\n  color: var(--gray_dark2);\n}\n\n@include scoped-zai-excluded('p') {\n  font-size: 1rem;\n}\n\n@include scoped-zai-excluded('h1') {\n  font-size: 3rem;\n}\n@include scoped-zai-excluded('h2') {\n  font-size: 2.25rem;\n}\n@include scoped-zai-excluded('h3') {\n  font-size: 1.5rem;\n}\n@include scoped-zai-excluded('h4') {\n  font-size: 1.25rem;\n}\n@include scoped-zai-excluded('h5') {\n  font-size: 1rem;\n}\n@include scoped-zai-excluded('h6') {\n  font-size: 0.875rem;\n}\n\n#adopt-controller-button {\n  bottom: 72px !important;\n  right: 16px !important;\n\n  svg > path {\n    fill: rgb(192, 192, 192) !important;\n  }\n}\n\nhtml {\n  box-sizing: border-box;\n}\n\n*,\n*::after,\n*::before {\n  box-sizing: inherit;\n}\n\n#root {\n  display: flex;\n  flex-direction: column;\n}\n\nbody {\n  font-family: 'Muli', Arial, sans-serif;\n  font-weight: 400;\n  font-size: 16px;\n  font-variant-ligatures: none;\n  text-rendering: geometricPrecision;\n  margin: 0;\n  padding: 0;\n  color: var(--gray);\n  background-color: var(--base_color2);\n  overflow-y: scroll;\n  min-height: 100vh;\n  transition: margin-bottom 200ms;\n\n  .apexcharts-canvas {\n    .apexcharts-toolbar {\n      z-index: 1;\n    }\n  }\n}\n\n@include scoped-zai-excluded('button, input, select, textarea') {\n  font-family: inherit;\n  font-weight: inherit;\n  font-size: inherit;\n  color: inherit;\n}\n\n@include scoped-zai-excluded('*:focus') {\n  outline: none;\n}\n\n@include scoped-zai-excluded('img') {\n  max-width: 100%;\n}\n\n@include scoped-zai-excluded('a, a:visited') {\n  text-decoration: none;\n}\n\n@include scoped-zai-excluded('button') {\n  background-color: transparent;\n  border: none;\n  cursor: pointer;\n}\n\n.link-color {\n  color: var(--color_primary_500);\n}\n\n@include scoped-zai-excluded('.sidebar-widget') {\n  margin-top: 16px;\n  border-radius: 4px;\n  background-color: var(--base_color2);\n  padding: 16px;\n\n  h4 {\n    margin-top: 0;\n    margin-bottom: 8px;\n    font-weight: bold;\n    font-size: 1.125em;\n\n    .subtitle {\n      display: block;\n      font-size: 0.7em;\n    }\n  }\n}\n\n@include scoped-zai-excluded('.bg-white') {\n  background-color: var(--base_color2);\n}\n\n.page-header {\n  position: relative;\n  z-index: 3;\n  margin-bottom: 20px;\n}\n\n.page-content {\n  z-index: 1;\n}\n\n// Grid layouts\n.grid-2-columns {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  grid-column-gap: 20px;\n}\n\n// Basic structure with a title and content\n.title-content {\n  display: grid;\n  grid-template-areas:\n    'title'\n    'content';\n  grid-row-gap: 16px;\n  grid-template-rows: min-content;\n  margin: 0 0 56px;\n}\n\n// Basic structure with a title, content and action area\n.title-content-actions {\n  display: grid;\n  grid-template-areas:\n    'title'\n    'content'\n    'actions';\n  grid-row-gap: 16px;\n  grid-template-rows: min-content;\n  margin: 0 0 20px;\n}\n\n// Basic structure with a title and actions side by side and content above\n.title-actions-content {\n  margin: 30px 0 56px;\n  display: grid;\n  grid-template-areas:\n    'title actions'\n    'content content';\n  grid-row-gap: 16px;\n  grid-template-rows: min-content;\n\n  > .title {\n    grid-area: title;\n    align-self: center;\n  }\n\n  > .actions {\n    grid-area: actions;\n    display: flex;\n    justify-content: flex-end;\n    align-items: center;\n\n    > * {\n      margin: 0 0 0 28px;\n    }\n  }\n\n  > .content {\n    grid-area: content;\n  }\n\n  > .actions-secondary {\n    grid-area: actions-secondary;\n    display: flex;\n    justify-content: flex-end;\n    align-items: center;\n  }\n\n  &.with-actions-secondary {\n    margin: 0 0 20px;\n    grid-template-areas:\n      'title actions'\n      'content content'\n      'actions-secondary actions-secondary';\n  }\n}\n\n// Helper for actions layout\n.actions-box {\n  display: grid;\n  grid-template-areas: 'left center right';\n  grid-column-gap: 20px;\n\n  .actions-left {\n    grid-area: left;\n    display: flex;\n    justify-content: flex-start;\n  }\n\n  .actions-center {\n    grid-area: center;\n    display: flex;\n    justify-content: center;\n  }\n\n  .actions-right {\n    grid-area: right;\n    display: flex;\n    justify-content: flex-end;\n  }\n}\n\n.apexcharts-tooltip,\n.custom-toltip-container,\n.tooltip-component {\n  color: var(--gray_dark2);\n}\n\n$tooltip-max-width: 225px !default;\n$tooltip-background-color: #000 !default;\n$tooltip-text-color: #000 !default;\n$tooltip-delay: 0.4s !default;\n$tooltip-duration: 0.1s !default;\n\n.tooltipped {\n  position: relative;\n}\n\n// This is the tooltip bubble\n.tooltipped::after {\n  position: absolute;\n  z-index: 1000000;\n  display: none;\n  padding: 5px 5px 7px;\n  font: normal normal 13px/1.5 'Muli';\n  -webkit-font-smoothing: subpixel-antialiased;\n  color: var(--base_color2);\n  text-align: center;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-wrap: break-word;\n  white-space: pre;\n  pointer-events: none;\n  content: attr(aria-label);\n  background: var(--base_color1);\n  border-radius: 4px;\n  opacity: 0;\n}\n\n// This is the tooltip arrow\n.tooltipped::before {\n  position: absolute;\n  z-index: 1000001;\n  display: none;\n  width: 0;\n  height: 0;\n  color: var(--base_color1);\n  pointer-events: none;\n  content: '';\n  border: 6px solid transparent;\n  opacity: 0;\n}\n\n// delay animation for tooltip\n@keyframes tooltip-appear {\n  from {\n    opacity: 0;\n  }\n\n  to {\n    opacity: 1;\n  }\n}\n\n// This will indicate when we'll activate the tooltip\n.tooltipped:hover,\n.tooltipped:active,\n.tooltipped:focus {\n  &::before,\n  &::after {\n    display: inline-block;\n    text-decoration: none;\n    animation-name: tooltip-appear;\n    animation-duration: $tooltip-duration;\n    animation-fill-mode: forwards;\n    animation-timing-function: ease-in;\n    animation-delay: $tooltip-delay;\n  }\n}\n\n.tooltipped-no-delay:hover,\n.tooltipped-no-delay:active,\n.tooltipped-no-delay:focus {\n  &::before,\n  &::after {\n    animation-delay: 0s;\n  }\n}\n\n.tooltipped-multiline:hover,\n.tooltipped-multiline:active,\n.tooltipped-multiline:focus {\n  &::after {\n    display: table-cell;\n  }\n}\n\n// Tooltipped south\n.tooltipped-s {\n  &::after {\n    top: 100%;\n    right: 50%;\n    margin-top: 6px;\n  }\n\n  &::before {\n    top: auto;\n    right: 50%;\n    bottom: -7px;\n    margin-right: -6px;\n    border-bottom-color: var(--base_color1);\n  }\n}\n\n// Tooltips above the object\n.tooltipped-n,\n.tooltipped-ne,\n.tooltipped-nw {\n  &::after {\n    right: 50%;\n    bottom: 100%;\n    margin-bottom: 6px;\n  }\n\n  .tooltipped-ne {\n    &::after {\n      right: auto;\n      left: 50%;\n      margin-left: -0.125em;\n    }\n  }\n\n  &::before {\n    top: -7px;\n    right: 50%;\n    bottom: auto;\n    margin-right: -6px;\n    border-top-color: var(--base_color1);\n  }\n}\n\n.tooltipped-ne {\n  &::after {\n    right: auto;\n    left: 50%;\n    margin-left: -12px;\n  }\n}\n\n.tooltipped-nw::after {\n  margin-right: -12px;\n}\n\n// Move the tooltip body to the center of the object.\n.tooltipped-s::after,\n.tooltipped-n::after {\n  transform: translateX(50%);\n}\n\n// Tooltipped to the left\n.tooltipped-w {\n  &::after {\n    right: 100%;\n    bottom: 50%;\n    margin-right: 6px;\n    transform: translateY(50%);\n  }\n\n  &::before {\n    top: 50%;\n    bottom: 50%;\n    left: -7px;\n    margin-top: -6px;\n    border-left-color: var(--base_color1);\n  }\n}\n\n// tooltipped to the right\n.tooltipped-e {\n  &::after {\n    bottom: 50%;\n    left: 100%;\n    margin-left: 6px;\n    transform: translateY(50%);\n  }\n\n  &::before {\n    top: 50%;\n    right: -7px;\n    bottom: 50%;\n    margin-top: -6px;\n    border-right-color: var(--base_color1);\n  }\n}\n\n// Multiline tooltips\n//\n// `.tooltipped-multiline` Add this class when you have long content.\n// The downside is you cannot preformat the text with newlines and `[w,e]`\n// are always `$tooltip-max-width` wide.\n.tooltipped-multiline {\n  &::after {\n    width: max-content;\n    max-width: $tooltip-max-width;\n    word-wrap: break-word;\n    white-space: pre-line;\n    border-collapse: separate;\n    text-align: left;\n    padding: 14px;\n  }\n\n  &.tooltipped-s::after,\n  &.tooltipped-n::after {\n    right: auto;\n    left: 50%;\n    transform: translateX(-50%);\n  }\n\n  &.tooltipped-w::after,\n  &.tooltipped-e::after {\n    right: 100%;\n  }\n}\n\n@media screen and (min-width: 0\\0) {\n  // IE11\n  .tooltipped-multiline::after {\n    width: $tooltip-max-width;\n  }\n}\n\n.notAllowed {\n  &.displayBlock {\n    display: block;\n  }\n\n  &.tooltipped-multiline {\n    &:after {\n      width: 150px;\n    }\n  }\n\n  cursor: pointer;\n\n  .isClickBlocked {\n    pointer-events: none;\n  }\n}\n\n.link-as-button {\n  background: var(--color_primary_500);\n  color: var(--base_color2);\n  font-size: 14px;\n  padding: 6px 16px;\n  line-height: 24px;\n  font-weight: 400;\n  border: 1px solid var(--color_primary_500);\n  border-radius: 4px;\n\n  &:hover {\n    background: var(--primary_dark1);\n  }\n}\n\n.provider {\n  height: 26px;\n  width: 26px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n\n  &.youtube {\n    background-color: var(--youtube);\n  }\n\n  &.facebook {\n    background-color: var(--facebook);\n  }\n\n  &.instagram {\n    background-color: var(--instagram);\n  }\n\n  &.tiktok {\n    background-color: var(--tiktok);\n  }\n\n  &.twitch {\n    background-color: var(--twitch);\n  }\n\n  .icon {\n    height: 16px;\n    width: 16px;\n    fill: var(--base_color2);\n  }\n}\n\n.column-headers {\n  background-color: var(--background);\n  border-radius: 4px;\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 15px;\n  color: var(--gray_dark2);\n\n  .header_active {\n    color: var(--color_primary_500);\n  }\n\n  .header-sortable {\n    span {\n      margin: 0 4px 0 0;\n    }\n  }\n}\n\n.pin-block {\n  justify-self: center;\n  justify-content: center;\n  display: flex;\n  align-items: center;\n}\n\n.CreatorCard {\n  .pin-block-card {\n    position: absolute;\n    top: 0;\n    left: 0;\n    z-index: 1;\n  }\n}\n\n.VideoCard {\n  .pin-block-card {\n    position: absolute;\n    top: 8px;\n    left: 8px;\n    z-index: 1;\n  }\n}\n\n.ContainerToasts {\n  position: fixed;\n  left: 50px;\n  bottom: 20px;\n  z-index: 9999;\n  width: fit-content;\n  max-width: 432px;\n  min-width: 350px;\n}\n\n.PrivateRoute {\n  padding-left: 72px;\n\n  @media only screen and (max-width: 600px) {\n    padding-left: 0px;\n    display: flex;\n    flex-direction: column;\n    min-height: 100vh;\n    max-height: 100vh;\n\n    & > * {\n      flex-shrink: 0;\n    }\n  }\n\n  &.fullScreen {\n    padding-left: 0px;\n  }\n}\n\n.hiddenOnMobile {\n  @media screen and (max-width: 768px) {\n    display: none;\n  }\n}\n\n.hiddenOnDesktop {\n  @media screen and (min-width: 768px) {\n    display: none;\n  }\n}\n\n.osano-cm-widget--position_right {\n  width: 55px;\n  height: 55px;\n  opacity: 0.5;\n  border-radius: 50%;\n  right: 16px;\n  bottom: 72px;\n  background-color: #c0c0c0;\n\n  .osano-cm-widget__outline {\n    stroke: #c0c0c0;\n  }\n\n  .osano-cm-widget__dot {\n    fill: #c0c0c0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
